import Logger from './Logger'

export default class Project {

    project = {}
    activeScene = 0
    activeVersion = 0

    constructor(project) {
        this.project = project

        return this
    }

    get id() {
        return this.project.id
    }

    get name() {
        return this.project.name
    }

    get code() {
        return this.project.code
    }

    get scenes() {
        return this.project.scenes
    }

    get scene() {
        return this.scenes[this.activeScene]
    }

    get versions() {
        return this.scene.versions
    }

    get version() {
        return this.versions[this.activeVersion]
    }

    get content() {
        return this.version.content
    }

    get width() {
        return this.version.size[0]
    }
    
    get height() {
        return this.version.size[1]
    }

    /**
     * Get width with frames size
     */
    get totalWidth() {
        let width = parseFloat(this.width)

        width += this.version.margin.left
        width += this.version.margin.right

        return width
    }

    get personalizedVersion() {
        return this.versions.find((version) => version.personalizedField)
    }

    /**
     * Get height with frames size
     */
    get totalHeight() {

        let height = parseFloat(this.height)

        height += this.version.margin.top
        height += this.version.margin.bottom

        return height
    }

    /**
     * Set project scene
     */
    setScene(scene) {
        this.activeScene = parseInt(scene)
    }

    /**
     * Set project version
     */
    setVersion(version) {
        this.activeVersion = parseInt(version)
    }

    /**
     * Save project version content
     */
    saveContent(content) {
        console.log('set project content', content)
        // this.version.content = content
    }


    /**
     * Find fonts used in a project
     * @returns array of fonts name
     */
    getUsedFonts() {
        let fonts = []

        // this.scenes.forEach((scene) => {

            this.versions
                .filter((version) => version.content.length)
                .forEach((version) => {
                    const content = JSON.parse(version.content)

                    content.objects
                        .filter((object) => 'fontFamily' in object)
                        .forEach((object) => fonts.push(object.fontFamily))
                })
        // })

        Logger.log('[Project][GetUsedFonts] Found', fonts)
        
        fonts = [...new Set(fonts)]

        Logger.log('[Project][GetUsedFonts] Remove duplicates', fonts)

        return fonts
    }
}